import { createContext } from 'react'
import type { EnqueueMode, PlayerState, PlayOptions, QueueItem, RepeatMode } from './types'

export interface PlayerContextValue {
  state: PlayerState
  getAnalyserNode: () => AnalyserNode | null
  getCurrentTime: () => number
  subscribeCurrentTime: (callback: () => void) => () => void
  play: (tracks: QueueItem[], options?: PlayOptions) => void
  pause: () => void
  resume: () => void
  togglePlay: () => void
  next: () => void
  prev: () => void
  seek: (time: number) => void
  setVolume: (volume: number) => void
  toggleMute: () => void
  toggleShuffle: () => void
  setRepeat: (mode: RepeatMode) => void
  setCrossfadeDuration: (seconds: number) => void
  setReplayGainEnabled: (enabled: boolean) => void
  setRadioMode: (enabled: boolean) => void
  setRadioFollow: (enabled: boolean) => void
  enqueue: (tracks: QueueItem[], mode?: EnqueueMode) => void
  addToQueue: (tracks: QueueItem[]) => void
  removeFromQueue: (index: number) => void
  moveInQueue: (from: number, to: number) => void
  clearQueue: () => void
  playTrackAt: (index: number) => void
}

export const PlayerContext = createContext<PlayerContextValue | undefined>(undefined)
